import { DefaultPageHeader } from 'layouts';
import type { EntityOptions, GroupDetail } from 'models';
import { Card } from 'ui';
import { useGetGroupEntityBreadcrumb, useGetGroupScopeName } from '../hooks';
import { type GroupScope, getGroupTypeFromScope } from '../models';
import { GroupsList } from './groups-list';
import { OrganizationsList } from './organizations-list';

type P = {
  entityScope: GroupScope;
  getPathToDetail: (id: string, options: EntityOptions) => string;
  group: GroupDetail;
};

const GroupEntities = ({ entityScope, getPathToDetail, group }: P) => {
  const getGroupScopeName = useGetGroupScopeName();
  const breadcrumbRoutes = useGetGroupEntityBreadcrumb({ entityScope, group });

  return (
    <>
      <DefaultPageHeader routes={breadcrumbRoutes} title={getGroupScopeName({ entityScope })} />
      <Card>
        {entityScope === 'organizations' ? (
          <OrganizationsList
            getPathToOrganizationDetail={(id) => getPathToDetail(id, { entityType: 'organization' })}
            groupId={group.id}
          />
        ) : (
          <GroupsList
            getPathToGroupDetail={(id) => getPathToDetail(id, { entityType: 'group' })}
            groupId={group.id}
            groupType={getGroupTypeFromScope({ entityScope })}
          />
        )}
      </Card>
    </>
  );
};

export default GroupEntities;
